export default '/static/frontend/ReachDigital/12gobiking/dist/assets/visa-983becc8.svg'